module.exports = function() {
  return new Worker(__webpack_public_path__ + "12ba7a8ca0c051638e45.worker.js");
};